import React__default, { createContext, useState, useContext } from 'react';

const DEFAULT_FRAME_AREA_SCOPE = {
  frame: null,
  header: null,
  footer: null,
  main: null,
  primaryAction: null,
  secondaryAction: null,
  primaryPanel: null,
  secondaryPanel: null
};
const DEFAULT_FRAME_CONTEXT = {
  area: {
    ...DEFAULT_FRAME_AREA_SCOPE
  },
  setFrameAreaRef: () => {}
};
const FrameContext = /*#__PURE__*/createContext({
  ...DEFAULT_FRAME_CONTEXT
});
function FrameProvider({
  children
}) {
  const setFrameAreaRef = data => {
    const [key, value] = data;
    updateFrameAreaRef(prevState => {
      const {
        area,
        ...state
      } = prevState;
      const newState = {
        ...state,
        area: {
          ...area,
          [key]: value
        }
      };
      return newState;
    });
  };
  const initialState = {
    ...DEFAULT_FRAME_CONTEXT,
    setFrameAreaRef
  };
  const [FrameState, updateFrameAreaRef] = useState(initialState);
  return /*#__PURE__*/React__default.createElement(FrameContext.Provider, {
    value: FrameState
  }, children);
}
function useFrameContext() {
  return useContext(FrameContext);
}

export { DEFAULT_FRAME_AREA_SCOPE, DEFAULT_FRAME_CONTEXT, FrameContext, FrameProvider, useFrameContext };
